import { createContext } from 'react';

export interface IGlobalErrorModalContent {
  title?: string;
  description?: string;
}

export interface IGlobalErrorContext {
  addErrorModal: (content?: IGlobalErrorModalContent) => void;
  closeErrorModal: () => void;
  showErrorModal: boolean;
  errorModalContent?: IGlobalErrorModalContent;
}

export const GlobalErrorContext = createContext({} as IGlobalErrorContext);
